import { helper as buildHelper } from '@ember/component/helper';

export default buildHelper(([f]) => (typeof f === 'function' ? f : (x) => x));
